import { getReserve } from '@/api'
//
export default {
	namespaced: true,
	//
	state: {
		reserve: false
	},
	//
	mutations: {
		set (state, reserve) {
			state.reserve = reserve
		},
	},
	//
	actions: {
		getReserve (store) {
			return getReserve()
				.then(response => {
					store.commit('set', response.data.result)
					return response
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/reserve.js